import Sprites from "../Sprites";
import FramesPlayer from "./FramesPlayer";
import SingleAnimation from "./SingleAnimation";

export default class Spran {
  constructor(clip, animationsDefinitions, callback) {
    this.sp = Sprites;
    this.clip = clip;
    this.animationsDefinitions = animationsDefinitions;
    this.anims = new Array();
    this.fp = null;
    this.currentId = -1;
    this.pausedId = -1;
    this.callback = callback;
  }

  init() {
    let a = this.animationsDefinitions;
    for (let x = 0; x < a.length; x++) {
      let anm = new SingleAnimation(a[x]);
      anm.init();
      this.anims.push(anm);
    }
  }

  setAnimation(id, callback) {
    if (!callback) {
      if (id === this.currentId) {
        return
      }
    }
    this.currentId = id;
    let a = this.anims;
    for (let x = 0; x < a.length; x++) {
      if (a[x].id === id) {
        this._startAnimation(a[x], callback);
        break;
      }
    }
  }

  getCurrentAnimName() {
    return this.currentId;
  }
  getCurrentFrame() {
    if (this.fp) {
      return this.fp.currentFrame;
    }
    return null;
  }

  _startAnimation(anim, callback) {
    this.dispatch({ type: Spran.EVENT_START_ANIMATION, data: { anim: anim } });
    this.fp = new FramesPlayer(this.clip, anim, this._eventsHandler.bind(this, anim), callback);
    this.fp.start();
  }

  _eventsHandler(anim, e) {
    if (e.type === FramesPlayer.EVENT_GOTO_ANIMATION) {
      this.setAnimation(e.data.id);
    }
    if (e.type === FramesPlayer.EVENT_END_ANIMATION) {
      this.dispatch({ type: Spran.EVENT_END_ANIMATION, data: { anim: anim } });
    }
  }

  pause() {
    if (this.fp) {
      this.pausedId = this.currentId;
      this.currentId = -1;
      this.fp = null;
    }
  }

  resume(animation = null) {
    if (!Pqp.isNullOrEmpty(animation)) {
      this.pausedId = animation;
    }

    if (!this.fp) {
      this.setAnimation(this.pausedId);
    }
  }

  paint() {
    if (this.fp) {
      this.fp.tick();
    }

  }

  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }



}

Spran.EVENT_START_ANIMATION = "eventStartAnimation";
Spran.EVENT_END_ANIMATION = "eventEndAnimation";
